import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {HAS_HQ} from '@constants/staticDropdowns';

export const HqFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --isHq'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        selection
        name='isHq'
        placeholder='HQ?'
        options={HAS_HQ}
        setValue={restoreFilterValues(filters, 'isHq')}
    />
);

HqFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
